const BMIChart = () => {
  return (
    <div className="bmi-chart-page">
      <div className="bmi-chart-frame">
      </div>
    </div>
  );
};

export default BMIChart;
